import APIService from 'services/APIService'

const api = APIService()

const taskLinksAPI = {
  fileLinks: (bpId, fileId) => api.get(`/building-passport/${bpId}/files/${fileId}/task-links`),
  taskRelated: taskId => api.get(`/tasks/${taskId}/related`),
  link: (actionId, taskId, relation) => api.post(`/actions/${actionId}/task-links`, { taskId, relation }),
  unlink: (actionId, taskId) => api.delete(`/actions/${actionId}/task-links/${taskId}`),
  dismiss: matchId => api.post(`/remedial-task-matches/${matchId}/dismiss`),
  searchTasks: (bpId, q) => api.get(`/building-passport/${bpId}/task-search`, { params: { q } }),
}

export default taskLinksAPI
